<template>
  <div id="filters" :key="refreshKey">
    <b-button class="apply-button" @click="applyFilters()">Apply</b-button>
    <b-field>
      <b-checkbox v-model="filterOptions.directOnly" v-on:input="applyFilters()">Direct only?</b-checkbox>
    </b-field>
    <b-field class="my-label" label="Price (ZAR)">
      <b-slider
        v-model="filterOptions.priceRange"
        :min="Math.floor(resultConstants.minPrice)"
        :max="Math.ceil(resultConstants.maxPrice)"
        v-on:dragend="applyFilters()"
        @change="applyFilters()"
        :step="1"
      ></b-slider>
    </b-field>
    <b-field v-if="!flags.isDomesticReturn" class="my-label" label="Travel Time (minutes)">
      <b-slider
        v-model="filterOptions.travelTime"
        :min="resultConstants.minTravelTime / 60000"
        :max="resultConstants.maxTravelTime / 60000"
        v-on:dragend="applyFilters()"
        @change="applyFilters()"
        :step="1"
      >
        <template
          v-for="(val, i) in [resultConstants.minTravelTime / 60000, resultConstants.maxTravelTime / 60000]"
        >
          <b-slider-tick :value="val" :key="`totalTime-${i}`">{{ val }}</b-slider-tick>
        </template>
      </b-slider>
    </b-field>
    <b-field class="my-label" label="Depart At:" expanded>
      <b-select v-model="departAt" expanded>
        <option value="AnyTime">Any time</option>
        <option value="Morning">Morning</option>
        <option value="Afternoon">Afternoon</option>
        <option value="Evening">Evening</option>
      </b-select>
    </b-field>
    <b-field
      v-if="searchParameters.tripType == 'return' || searchParameters.tripType == 'multi'"
      class="my-label"
      label="Return At:"
      expanded
    >
      <b-select v-model="returnAt" expanded>
        <option value="AnyTime">Any time</option>
        <option value="Morning">Morning</option>
        <option value="Afternoon">Afternoon</option>
        <option value="Evening">Evening</option>
      </b-select>
    </b-field>
    <b-field
      v-if="searchParameters.tripType == 'return' || searchParameters.tripType == 'multi'"
      class="my-label"
      label="Outbound Departure Time"
    >
      <b-slider
        v-model="filterOptions.outboundTime"
        :min="0"
        :max="24"
        v-on:dragend="applyFilters()"
        @change="applyFilters()"
        :step="1"
      >
        <template v-for="(val, i) in filterOptions.outboundTime">
          <b-slider-tick :value="val" :key="`outboundTime-${i}`">{{ asStringTime(val) }}</b-slider-tick>
        </template>
      </b-slider>
    </b-field>
    <b-field class="my-label" label="Return Departure Time">
      <b-slider
        v-model="filterOptions.returnTime"
        :min="0"
        :max="24"
        v-on:dragend="applyFilters()"
        @change="applyFilters()"
        :step="1"
      >
        <template v-for="(val, i) in filterOptions.returnTime">
          <b-slider-tick :value="val" :key="`returnTime-${i}`">{{ asStringTime(val) }}</b-slider-tick>
        </template>
      </b-slider>
    </b-field>
    <b-field></b-field>
    <div class="block">
      <b-checkbox v-model="selectAllAirlines" v-on:input="toggleAllAirlines()">Select all?</b-checkbox>
      <b-checkbox
        v-for="airline in this.$store.state.resultConstants.marketingAirlines"
        :key="airline.index"
        v-model="filterOptions.airlines"
        v-on:input="applyFilters(); selectAllAirlines = false;"
        :native-value="airline"
      >{{customFormatAirline(searchResults.airlineNames[airline])}}</b-checkbox>
    </div>
    <b-button type="is-secondary" class="apply-button" @click="resetFilters()">Reset</b-button>
  </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";
import _ from "lodash";

export default {
  name: "filters",
  data: function() {
    return {
      filterOptions: {
        priceRange: [0, 900000],
        travelTime: [0, 900000],
        airlines: this.$store.state.resultConstants.marketingAirlines,
        outboundTime: [0, 24],
        returnTime: [0, 24],
        directOnly: false
      },
      selectAllAirlines: true,
      refreshKey: 0,
      departAt: "AnyTime",
      returnAt: "AnyTime"
    };
  },
  computed: {
    ...mapState([
      "searchResults",
      "flags",
      "resultConstants",
      "searchParameters",
      "filteredOutbound"
    ])
  },
  created() {
    if (this.$store.state.searchParameters.departureTime) {
      this.departAt = this.$store.state.searchParameters.departureTime;
    }
  },
  mounted() {
    if (this.filteredOutbound.length > 0) {
      this.applyFilters();
    }
  },
  methods: {
    customFormatAirline(airline) {
      return airline === 'X1' ? 'Lift' : airline;
    },
    applyFilters() {
      this.$store.commit("filterFlights", this.filterOptions);
    },
    resetFilters() {
      this.filterOptions = {
        priceRange: [
          this.resultConstants.minPrice - 1,
          this.resultConstants.maxPrice + 1
        ],
        travelTime: [
          this.resultConstants.minTravelTime / 60000,
          this.resultConstants.maxTravelTime / 60000
        ],
        airlines: this.$store.state.resultConstants.marketingAirlines,
        outboundTime: [0, 24],
        returnTime: [0, 24],
        directOnly: false
      };
      this.applyFilters();
    },
    asNumberTime(time) {
      return Math.round(moment.duration(time).asHours() * 1e2) / 1e2;
    },
    asStringTime(minutes) {
      var sign = minutes < 0 ? "-" : "";
      var min = Math.floor(Math.abs(minutes));
      var sec = Math.floor((Math.abs(minutes) * 60) % 60);
      return (
        sign + (min < 10 ? "0" : "") + min + ":" + (sec < 10 ? "0" : "") + sec
      );
    },
    toggleAllAirlines() {
      if (!this.selectAllAirlines) {
        this.filterOptions.airlines = [];
      } else {
        this.filterOptions.airlines = this.resultConstants.marketingAirlines;
      }
      this.applyFilters();
    }
  },
  watch: {
    resultConstants: {
      handler(newVal) {
        this.filterOptions.priceRange = [newVal.minPrice, newVal.maxPrice];
        this.filterOptions.travelTime = [
          newVal.minTravelTime / 60000,
          newVal.maxTravelTime / 60000
        ];
        this.filterOptions.airlines = newVal.marketingAirlines;
        this.refreshKey += 1;
      },
      deep: true
    },
    departAt: {
      handler(newVal) {
        switch (newVal) {
          case "AnyTime":
            this.filterOptions.outboundTime = [0, 24];
            break;
          case "Morning":
            this.filterOptions.outboundTime = [0, 12];
            break;
          case "Afternoon":
            this.filterOptions.outboundTime = [12, 17];
            break;
          case "Evening":
            this.filterOptions.outboundTime = [17, 24];
            break;
          default:
            break;
        }
        this.applyFilters();
      }
    },
    returnAt: {
      handler(newVal) {
        switch (newVal) {
          case "AnyTime":
            this.filterOptions.returnTime = [0, 24];
            break;
          case "Morning":
            this.filterOptions.returnTime = [0, 12];
            break;
          case "Afternoon":
            this.filterOptions.returnTime = [12, 17];
            break;
          case "Evening":
            this.filterOptions.returnTime = [17, 24];
            break;
          default:
            break;
        }
        this.applyFilters();
      }
    }
  },
  beforeDestroy() {
    this.applyFilters();
  }
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/settings.scss";

#filters {
  display: flex;
  flex-direction: column;
  padding-top: 1.5em;
}

.apply-button {
  margin-bottom: 0.75em;
  border-color: $secondary-color;
}

.block {
  margin-top: 1em;
  * {
    margin-left: 0 !important;
    margin-bottom: 0.75em !important;
  }
  display: flex;
  flex-direction: column;
}

@media (min-width: 781px) {
  #filters {
    padding-top: 0;
  }
}
</style>

<style lang="scss">
.b-slider .b-slider-tick-label {
  font-size: 0.75rem;
  position: absolute;
  top: 0.75em !important;
}
.my-label .label {
  font-size: 0.9em !important;
  font-weight: 600 !important;
}
</style>